module.exports = __webpack_public_path__ + "img/ge.f56c0f35.svg";